<template>
  <scroller
    lock-x scrollbar-y
    use-pullup
    @on-pullup-loading="loadMore"
    :pullup-config="pullConfig"
    height="100%"
    v-if="totalCount">
    <div>
      <group v-for="(item,index) in dataList" :key="index">
        <cell class="cus_info" :bdStart="true" @click.native="showDetail(item.car_id)">
          <img slot="icon" class="cus_img" src="../../stylesheets/images/car.png">
          <p slot="after-title" class="cus_title">{{item.plate_number}}{{item.insurance_rating | formatIns}}</p>
          <p slot="after-title" class="cus_title opacity7">续保员：{{item.employee_name}}</p>
          <p slot="after-title" class="cus_title opacity7">距离下次续保{{item.insurance_expires_in}}天</p>
          <div slot="value">
            <p class="ins_time">{{item.visited_at | formatTime}}</p>
          </div>
        </cell>
      </group>
      <p class="tip-text1">共{{totalCount}}条记录</p>
    </div>
  </scroller>
  <no-car v-else></no-car>
</template>
<script>
import {
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import NoCar from '../components/NoCar'
import util from '../../common/util'

export default {
  components: {
    NoCar,
    Scroller,
    Cell,
    Group
  },
  data() {
    return {
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      queryForm: {
        page: 1,
        count: 10
      },
      totalCount: 0,
      totalPage: 0,
      dataList: []
    }
  },
  mounted() {
    this.getData()
  },
  filters: {
    formatTime(time) {
      return util.formatTime(time, 'hh:mm')
    },
    formatIns(ins) {
      if (!ins || ins === '未知') {
        ins = ''
      } else {
        ins = '（保险' + ins + '类）'
      }
      return ins
    }
  },
  methods: {
    getData() {
      this.$rest.cus.getTodayVisitorList(this.queryForm).then(res => {
        if (res.code === 0) {
          let data = res.data
          let count = this.queryForm.count
          this.dataList = data.visits
          this.totalCount = data.total_count
          this.totalPage = parseInt((this.totalCount + count - 1) / count)
        } else {
          this.showToast(res.message)
        }
      })
    },
    loadMore(done) {
      if (this.queryForm.page < this.totalPage) {
        ++this.queryForm.page
        this.$rest.cus.getTodayVisitorList(this.queryForm).then(res => {
          if (res.code === 0) {
            let data = res.data
            let count = this.queryForm.count
            this.totalCount = data.total_count
            this.totalPage = parseInt((this.totalCount + count - 1) / count)
            this.dataList.push(...data.visits)
            done(100)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        done()
      }
    },
    showDetail(id) {
      this.$router.push({
        path: '/cus_info',
        query: {
          car_id: id
        }
      })
    }
  }
}

</script>
<style scoped lang="less">
@import "../../stylesheets/modules/cus/info.less";
</style>
